import { render, staticRenderFns } from "./AssignCardDialog.vue?vue&type=template&id=e5a01254"
import script from "./AssignCardDialog.vue?vue&type=script&lang=js"
export * from "./AssignCardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports